import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "antd";
import FormItem from "../../general/form-item";

const ChangePasswordForm: React.FC = () => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const passwordPattern = {
    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/,
    message: t("weak_password"),
  };

  return (
    <>
      <Controller
        name="oldPassword"
        control={control}
        rules={{ required: t("field_is_required_message") }}
        render={({ field, fieldState }) => (
          <>
            <FormItem label={t("old_password")} required>
              <Input.Password {...field} />
            </FormItem>
            {fieldState.error && (
              <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                {fieldState.error.message}
              </div>
            )}
          </>
        )}
      />

      <Controller
        name="password"
        control={control}
        rules={{
          required: t("field_is_required_message"),
          pattern: passwordPattern,
          minLength: {
            value: 8,
            message: t("invalid_password"),
          },
          maxLength: {
            value: 32,
            message: t("invalid_password"),
          },
        }}
        render={({ field, fieldState }) => (
          <>
            <FormItem label={t("new_password")} required>
              <Input.Password {...field} />
            </FormItem>
            {fieldState.error && (
              <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                {fieldState.error.message}
              </div>
            )}
          </>
        )}
      />
    </>
  );
};

export default ChangePasswordForm;
